import styled from 'styled-components';

// The required star, in amber to match the form builder and the on-page form
// (FormFillCanvas) — amber is the one colour that means "required" on the
// inspection form. Shown on fields the builder marked `required`, the ones
// Create Report lists while they are blank.
const RequiredMark = styled.span.attrs({ 'aria-hidden': true, children: '*' })`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 14px;
  height: 14px;
  margin-left: 6px;
  border-radius: 50%;
  background: var(--warning-500, #e0a012);
  color: var(--neutral-0, #fff);
  font-size: 11px;
  font-weight: 700;
  line-height: 1;
  vertical-align: middle;
`;

export default RequiredMark;
